import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { XlMapperRoutingModule } from './xl-mapper-routing.module';
import { XlMapperComponent } from './xl-mapper.component';
import { XlmapperDialogComponent } from './xlmapper-dialog/xlmapper-dialog.component';
import { MatIconModule } from '@angular/material/icon';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { DirectiveModule } from 'src/app/shared/directive/directive.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatStepperModule } from '@angular/material/stepper';
import { FileUploadModule } from 'ng2-file-upload';
import { SuccessFalureModule } from 'src/app/shared/success-falure/success-falure.module';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSelectModule } from '@angular/material/select';


@NgModule({
  declarations: [
    XlMapperComponent,
    XlmapperDialogComponent
  ],
  imports: [
    CommonModule,
    XlMapperRoutingModule,
    SharedModule,
    MatIconModule,
    DirectiveModule,
    NgxMatSelectSearchModule,
    FileUploadModule,
    MatStepperModule,
    SuccessFalureModule,
    MatAutocompleteModule,
    MatSelectModule,
  ],exports:[
    XlMapperComponent
  ]
})
export class XlMapperModule { }
